import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import { m } from '../../utils';
import './parking.css';

class DriverComments extends Component {
  renderComments = () =>
    this.props.booking.comments.map(comment => {
      if (comment.visible) {
        return (
          <div key={comment.comment} className="individual-comment">
            <p>
              <b>{comment.username}:</b> {comment.comment}
            </p>
            <p className="comment-created">
              <i>{m(comment.created_at).calendar()}</i>
            </p>
          </div>
        );
      }
      return null;
    });

  render() {
    const { writeComment } = this.props;
    return (
      <div className="comment-box">
        <div className="comment-list">{this.renderComments()}</div>
        <TextField
          className="search-bar"
          name="search"
          floatingLabelText="Post Comment"
          style={{ width: '100%' }}
          onChange={evt => writeComment(evt.target.value)}
        />
      </div>
    );
  }
}

export default DriverComments;



// WEBPACK FOOTER //
// ./src/components/Parking/DriverComments.js